import React from 'react'
import AboutView from 'views/About'


const AboutContainer = () => {
    return (
        <AboutView/>
    )
}

export default AboutContainer
